/** Utilities for zone table. */
import { get } from 'lodash';
// @tcc
import { getMessage } from 'util/locale';
import { createUnit, inferUnit } from 'util/unitConversion';

// constants
import COLORS from 'constants/colors';
import { applicationTypes } from 'constants/scripts';

// Selectors
import { getApplicationsForZoneByType, getZonesArray } from 'scripts/zones/selectors';

// Util
import { formatNumberK, decimalPoint } from 'util/formatters/numberFormatter';
import { sortByArea } from 'util/sort';
import { hexToRgb } from 'util/color';
import { styleMethods } from 'dataviz/config/map.js';
import { zoneIsSelected } from 'util/zoneDrawing';

/* Formatting specific to the display of the table. Refactor anything more general. Expect formatting to
   vary later based on unit type for i18n reasons. */
const _formatRate = (rate) => formatNumberK(rate.q);
const _formatAverageYield = (averageYield, allowDecimalByCountry) =>  
  allowDecimalByCountry ? decimalPoint(averageYield.q.toFixed(1)) : String(Math.round(averageYield.q));
export const _formatArea = (area, setPrecision) => {
  const precision = setPrecision ? setPrecision : 0;
  return get(area, 'q') >= 1
    ? createUnit(area.q, area.u, precision).toString({ fullName: false })
    : getMessage('text__less-than-with-unit', 
      { lessThanText: '1', areaUnit: inferUnit('area').symbol.quantitySpecific });
};

const _getColorForZone = ({ script, productValidationValues, zone }) => {
  const style = styleMethods.seedRate(script, productValidationValues, zone);
  return hexToRgb(style.fillColor);
};

export const getRateHeaderText = unit => getMessage('label-text__population-rate--short', { unit });
export const getYieldHeaderText = unit => getMessage('label-text__average-yield--short', { unit });
export const getAreaHeaderText = unit => getMessage('label-text__area--short', { unit });

// Assumes advanced planting recommendations with a single product.
export const formatZoneRowsForScenario = ({ 
  allowDecimalByCountry, 
  productValidationValues, 
  scenario,
  selectedZoneIds
}) => { // Scenario is just script store format.
  const rows = [];
  const zonesArray = getZonesArray(get(scenario, 'zones'))
  .sort(sortByArea);
  zonesArray.forEach((zone, rowI) => {
    const firstSeedApplication = getApplicationsForZoneByType({ zone, applicationType:applicationTypes.SEED })[0];
    rows.push({
      color:_getColorForZone({ script: scenario, productValidationValues, zone }),
      name:getMessage('title-text__zone', { num:rowI+1 }),
      zoneId: rowI+1,
      zoneInternalId: get(zone, 'meta.zoneId', ''),
      rateText:_formatRate(firstSeedApplication.rate),
      rate: firstSeedApplication.rate.q,
      averageYieldText:_formatAverageYield(firstSeedApplication['target-yield'], allowDecimalByCountry),
      averageYield: firstSeedApplication['target-yield'].q,
      areaText:_formatArea(zone.meta.area),
      area: get(zone, 'meta.area.q', 0),
      isDeadZone: get(zone, 'meta.isDeadZone', false),
      isSelected: zoneIsSelected(selectedZoneIds, zone)
    });
  });
  return rows;
};

export const formatPlaceholderZoneRows = (zoneCount) => {
  const placeHolderSymbol = getMessage('label-text__placeholder-symbol');
  const rows = [];
  for (let rowI = 0; rowI < zoneCount; ++rowI) {
    rows.push({
      color:COLORS.colorBulletNull,
      name:getMessage('title-text__zone', { num:rowI }),
      rateText:placeHolderSymbol,
      averageYieldText:placeHolderSymbol,
      areaText:placeHolderSymbol
    });
  }
  return rows;
};
